import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { Alert } from "@grandvisionhq/iris-ui";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useDynamicModule } from "@grandvisionhq/utils";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const loadModule = async () => {
  const { PickupPointsFinder } = await import(
    /* webpackChunkName: 'grandvisionhq-pickup-points' */
    "@grandvisionhq/pickup-points"
  );
  return PickupPointsFinder;
};
const usePickupPointsModule = () => useDynamicModule(loadModule, "@grandvisionhq/pickup-points", []);
const PickupPointsFinderContainer = ({
  errorMessage,
  onPickupPointSelect,
  itemsToBeShipped
}) => {
  const [PickupPointsFinder, loading, error] = usePickupPointsModule();
  const { featureConfigs } = useFeatureToggles();
  const { pickupPoints } = useCheckoutSettings();
  if (loading) {
    return /* @__PURE__ */ React.createElement(Loader, null);
  }
  if (error || !PickupPointsFinder) {
    return /* @__PURE__ */ React.createElement(Alert, { variant: "error", notifyScreenReader: false, className: "alert-m-default" }, errorMessage);
  }
  return /* @__PURE__ */ React.createElement(
    PickupPointsFinder,
    {
      view: "modal",
      onPickupPointSelect,
      itemsToBeShipped,
      showCityField: !!pickupPoints?.showCityField,
      mapOptions: { mapId: featureConfigs?.googleDynamicMapsMapId }
    }
  );
};
export {
  PickupPointsFinderContainer
};
//# sourceMappingURL=PickupPointsFinderContainer.js.map
